import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeScript'
})
export class SafeScriptPipe implements PipeTransform {

  constructor(
    protected sanitizer: DomSanitizer
  ) {}

  transform(value: any, args?: any): any {
    return this.sanitizer.bypassSecurityTrustScript(value);
  }


}
